// Components
import { Box, Button, Divider, Grid, GridItem, HStack, Stat, StatHelpText, StatLabel, StatNumber, Text, useDisclosure } from "@chakra-ui/react"
import { Tag } from "components"
import { Moment } from "config"

// Config
import { Mask } from "config"
import Vouchers from "./vouchers"
import { useConsultant, useConsultantVouchers } from "hooks"

export default function General({ data }){
    
    const consultant = useConsultant(data?.id)
    const vouchers = useConsultantVouchers(data?.id)
    const vouchersModal = useDisclosure()


    return(
    <>
    <HStack>
        
        <Stat>
            <StatLabel>PIN Atual</StatLabel>
            <StatNumber>{consultant.data?.career?.current_career?.title}</StatNumber>
            <StatHelpText><Tag label="Premiação" children={`R$ ${Mask.price(consultant.data?.career?.current_career?.award)}`} /></StatHelpText>
        </Stat>

        <Stat>
            <StatLabel>Bônus disponível</StatLabel>
            <StatNumber color={consultant.data?.bonus_balance < 0 ? 'red' : 'green'}>R$ {Mask.price(consultant.data?.bonus_balance)}</StatNumber>
            <StatHelpText textTransform="capitalize">{Moment().startOf('month').format('DD-MMM')} &mdash; {Moment().endOf('month').format('DD-MMM')}</StatHelpText>
        </Stat>

        <Stat>
            <StatLabel>Pontos Qualificáveis</StatLabel>
            <StatNumber color="orange">{Mask.price(consultant.data?.qualified_points_balance)} pontos</StatNumber>
            <StatHelpText><Tag label="Valor máximo por equipe" children={`VME: ${Mask.price(consultant.data?.career?.current_career?.vme)} pontos`} /></StatHelpText>
        </Stat>

    </HStack>

    <Divider my={6} />

    <Grid templateColumns="1fr 1fr 1fr">

        <GridItem>
            <Box borderRadius={4} w="100%" borderWidth={1} borderStyle="dashed" py={6} textAlign="center">
                <Text children={`${vouchers.data?.total ?? 0} vouchers disponíveis`} fontWeight="bold" />
                <Button children="Ver vouchers" size="sm" mt={2} onClick={vouchersModal.onOpen} isLoading={vouchers.isFetching} />
            </Box>
        </GridItem>

    </Grid>

    <Vouchers {...vouchersModal} data={consultant?.data} />
    </>
    )
}